<template>
  <div class="dwell">
    <div class="conauto">
      <!-- 内容 -->
      <div class="contentText">
        <!--轮播  -->
        <div class="Textshang" v-if="data.images">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in data.images" :key="index"
              ><img :src="'http://www.weaiove.com' + item.image" alt=""
            /></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="prev" @click="changeSwiper(false)"></div>
          <div class="next" @click="changeSwiper(true)"></div>
        </div>
        <!--天津｜爱情  -->
        <div class="Textzhong">
          <div class="title">{{ data.city }} | {{ data.title }}</div>
          <div class="jieshao">{{ data.introduction }}</div>
        </div>
        <!-- 文字 -->
        <div class="Textxia">{{ data.description }}</div>
      </div>
      <!-- 关闭 -->
      <div class="guanbi" @click="$emit('close', false)">
        <div class="guanbiimg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

export default {
  name: "dwell",
  props: {
    data: {
      type: Object,
      dafault: {},
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: true,
      },
    };
  },
  methods: {
    changeSwiper(bol) {
      bol ? this.swiper.slideNext() : this.swiper.slidePrev();
    },
  },
  directives: {
    swiper: directive,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>

<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
.dwell {
  padding: 133px 15px 132px;
}
.contentText {
  padding: 11px 16px 73px 15px;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: 15px;
}
.guanbi {
  width: 100%;
  margin: 0 auto;
}
.guanbiimg {
  width: 40px;
  height: 40px;
  background: url("../../assets/images/tianchaung1@2x .png") no-repeat left top;
  background-size: 100% 100%;
  margin: 0 auto;
}
.Textshang {
  width: 314px;
  height: 176px;
  position: relative;
  .prev {
    width: 30px;
    height: 30px;
    position: absolute;
    left: 10px;
    top: 50%;
    margin-top: -15px;
    z-index: 1000;
    background: url("../../assets/images/tianchaung 1x1.png") no-repeat;
    background-size: 100% 100%;
  }
  .next {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -15px;
    z-index: 1000;
    background: url("../../assets/images/tianchaung 1x2.png") no-repeat;
    background-size: 100% 100%;
  }
  img {
    width: 314px;
    height: 176px;
    border-radius: 5px;
  }
}
.Textzhong {
  margin: 13px 0 10px 0;
}
.title {
  font-size: 16px;
  font-family: "苹方-简 中黑体";
  line-height: 22px;
  color: #333333;
}
.jieshao {
  color: #e95506;
  font-size: 13px;
  line-height: 18px;
  font-family: "苹方-简 中黑体";
  margin-top: 5px;
}
.Textxia {
  color: #999999;
  font-size: 13px;
  font-family: "苹方-简 常规体";
  line-height: 18px;
}
</style>
